import {
  HubConnectionBuilder,
  HubConnectionState,
  LogLevel,
} from '@microsoft/signalr';

const HUB_URL = 'https://aiducatortestingapisv2.ctsdemo.ae/notification-hub';

let connection = null;
let startPromise = null;

export function getNotificationsConnection(getToken) {
  if (connection) return connection;

  connection = new HubConnectionBuilder()
    .withUrl(HUB_URL, {
      accessTokenFactory: () => getToken?.() || '',
      withCredentials: false, // important for your CORS error (explained below)
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000])
    .configureLogging(LogLevel.Information)
    .build();

  return connection;
}

export function startNotifications(getToken) {
  const conn = getNotificationsConnection(getToken);

  if (conn.state === HubConnectionState.Connected) return Promise.resolve(conn);
  if (conn.state === HubConnectionState.Connecting && startPromise)
    return startPromise;

  startPromise = conn
    .start()
    .then(() => conn)
    .finally(() => {
      // allow future re-start attempts if it disconnects later
      startPromise = null;
    });

  return startPromise;
}
